import { FiCopy, handleCopy } from "@/components/common/commonFunction/handleCopy";
import { useState } from "react";

export default function BMICalculator() {
  const [errors, setErrors] = useState({});
  const [bmi, setBmi] = useState(null);
  const [info, setInfo] = useState("");
  const [height, setHeight] = useState("");
  const [weight, setWeight] = useState("");
  const [copy, setCopy] = useState(false);

  const handleOnChangeW = (e) => {
    setBmi("");
    setInfo(" ");
    setWeight(e.target.value);
    setCopy(false);
    setErrors({ ...errors, ["weight"]: "" });
  };
  const handleOnChangeH = (e) => {
    setBmi("");
    setInfo(" ");
    setHeight(e.target.value);
    setCopy(false);
    setErrors({ ...errors, ["height"]: "" });
  };

  const validationData = () => {
    let formIsValid = true;
    let errors = {};
    if (!height) {
      formIsValid = false;
      errors["height"] = "* Please enter height";
    }
    if (!weight) {
      formIsValid = false;
      errors["weight"] = "* Please enter weight";
    }
    setErrors(errors);
    return formIsValid;
  };

  const handleBmi = () => {
    if (validationData()) {
      const heightInMeters = Number(height) / 100;
      const bmi = (Number(weight) / (heightInMeters * heightInMeters)).toFixed(
        1
      );
      setBmi(Number(bmi));
      if (Number(bmi) < 18.5) {
        setInfo("Underweight");
      } else if (Number(bmi) >= 18.5 && Number(bmi) <= 24.9) {
        setInfo("Healthy");
      } else if (Number(bmi) >= 25 && Number(bmi) < 30) {
        setInfo("Overweight");
      } else {
        setInfo("Obese");
      }

      setCopy(false);
    }
  };

  return (
    <>
      <div>
        <div className="children-box-alignment">
          <div className="percentage-calculator-design">
            <div className="input-new">
              <label>Enter Height(cm)</label>

              <input
                type="number"
                value={height}
                onChange={(e) => {
                  handleOnChangeH(e);
                }}
                placeholder="165"
                className={errors["height"] && "error-input"}
              />
              <span className="text-sm text-red-700">{errors["height"]}</span>
            </div>
            <div className="input-new">
              <label>Enter Weight(kg)</label>

              <input
                type="number"
                value={weight}
                onChange={(e) => {
                  handleOnChangeW(e);
                }}
                placeholder="72"
                className={errors["weight"] && "error-input"}
              />

              <span className="text-sm text-red-700">{errors["weight"]}</span>
            </div>
            <div className="button arithmetic-button-center-alignment-new-one">
              <button onClick={handleBmi}>Calculate</button>
            </div>
            {bmi && (
              <div className="commom-box-new">
                <div className="copy-icon-new">
                  <FiCopy
                    onClick={() => handleCopy(bmi + " " + info, setCopy)}
                  />

                  {copy && (
                    <div>
                      {" "}
                      <span>Copied</span>
                    </div>
                  )}
                </div>

                <div className="input-new relative">
                  <label>BMI:-</label>
                  <input
                    value={bmi + " " + info}
                    placeholder="26.4 Overweight"
                    disabled={true}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
